"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactToggleButton = _interopRequireDefault(require("react-toggle-button"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class ToggleButton extends _react.Component {
  constructor(props) {
    super(props);
    this.onToggle = this.onToggle.bind(this);
    this.getTogglelabel = props.getTogglelabel;
    this.state = {
      value: props.value
    };
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      value
    } = this.props;
    if (prevProps.value !== value) {
      this.setState({
        value: value
      });
    }
  }
  onToggle() {
    const {
      value
    } = this.state;
    const {
      label,
      parent
    } = this.props;
    this.setState({
      value: !value
    });
    this.getTogglelabel(label, !value, parent);
  }
  render() {
    const toggleColor = {
      active: {
        base: '#2D6BFF'
      },
      inactive: {
        base: '#989EA4'
      }
    };
    const obj = this.props.onToggle ? {} : {
      ...this.state,
      onToggle: this.onToggle
    };
    const {
      label
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, label && /*#__PURE__*/_react.default.createElement("label", {
      role: "label"
    }, label), /*#__PURE__*/_react.default.createElement(_reactToggleButton.default, (0, _extends2.default)({}, this.props, obj, {
      colors: this.props.colors || toggleColor
    })));
  }
}
exports.ToggleButton = ToggleButton;
ToggleButton.defaultProps = {
  value: true
};
ToggleButton.propTypes = {
  /** Function to switch flag between ON and OFF */
  onToggle: _propTypes.default.func,
  /** Specifies boolean value for ON and OFF */
  value: _propTypes.default.bool.isRequired
};